import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canCloseReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

const BulkClosePayloadSchema_ = z.object({});
export interface ClosePayload extends z.infer<typeof BulkClosePayloadSchema_> {}

/** Reopen exists for a closed return, so this one is not irreversible. */
export const closeReturnAction = defineReturnAction<ClosePayload>({
  label: "Close",
  mutation: "closeReturns",
  permissions: [ReturnsAndClaimsPermissions.CLOSE_RETURN],
  isEligible: ({ return_ }) => canCloseReturn({ return_ }),
  payloadSchema: BulkClosePayloadSchema_,
  examplePayload: {},
});
